import { leadShortInfoType } from './leadsApiTypes';

export type ActStatus = "Отклонено Агентом" | "Подписано ФИНЛАБ" | "Подписано ООО \"ФИНЛАБ\"" | "Подписано Агентом" | "Подписано партнером" | "На подписании Агентом";

export enum ClientTypesEnum {
	ul = "ul",
	ip = "ip"
}

export enum ClientTypes {
	all = "Все клиенты",
	ul = "Юридическое лицо",
	ip = "Индивидульный предприниматель"
}
export const clientTypesEnumMap: { [key in ClientTypes]?: ClientTypesEnum } = {
	[ClientTypes.ul]: ClientTypesEnum.ul,
	[ClientTypes.ip]: ClientTypesEnum.ip
};

export type GetClientsQueryType = {
	Inn?: string,
	Region?: string,
	CompanyName?: string,
	ClientType?: string,
	offset?: number,
	count?: number,
}

export type AgentAct = {
	id: number,
	companyName: string,
	inn: string,
	period: string,
	changeDate: string,
	status: ActStatus,
	documentId: number,
	documentName: string,
	sum: number,
	isSigned: boolean,
}

export type AgentActsData = AgentAct[]

export type AgentLeadsData = {
	leads: leadShortInfoType[],
	companyNames: string[],
	statuses: string[],
}

export type AgentClients = {
	userId: string,
	companyName: string,
	clientType: ClientTypesEnum,
	inn: string,
	region: string,
	regionCode: number,
	timeZone: string,
	localTime: string,
}

export type AgentClientsListType = {
	clientCount: number,
	clients: AgentClients[],
	regions: string[]
	clientTypes: string[];
	inns?: string[];
	companyNames?: string[];
	pagination?: {
		offset: number,
		count: number,
		total: number,
	}
}